import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) =>
  (data: { countryCode: string; phone: string }) =>
    makeCall<undefined>('POST', '/api/v2/validation/phone', {
      data,
    });
